import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { Stats } from '@this+that/models';

const GET_STATS = gql`
  query getStats {
    getStats {
      statType
      statTimestamp
      users
      teams
      invitedUsers
      inboxEntries
      contacts
      taskGroups
      bannerContent
      googleCredentials
      microsoftCredentials
      slackCredentials
      slackUserCredentials
      integrationRequests
      userCommunications
      recurrenceInboxEntries
      doBoxConfigs
      pushSubscriptions
      activityLogs
      userCommunicationAgents
      agentExecutions
      orphanedTeamMembers
      brokenTeams
      orphanedInboxEntries
      orphanedTaskGroups
      orphanedRecurrenceEntries
      staleWebSockets
      brokenTeamInvites
    }
  }
`;

interface GetStatusData {
  getStats: Stats[];
}

export function useGetStats() {
  const { loading, error, data, refetch } = useQuery<GetStatusData>(GET_STATS);

  return {
    loading,
    error,
    data,
    refetch,
  };
}
